import { createServerFn } from "@tanstack/react-start"
import { getRoutes, saveRoutes } from "../lib/db"
import { previewImageUrl, rwgpsIdFromUrl, type Route } from "../lib/types"
import { adminAuthMiddleware } from "../middleware/auth"

export const routesGet = createServerFn().handler(async () => {
  const routes = getRoutes()
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((r) => ({ ...r, previewImageUrl: previewImageUrl(r.url) }))
  return routes
})

export interface RouteCreateInput {
  name: string
  url: string
}

export const routeCreate = createServerFn({ method: "POST" })
  .middleware([adminAuthMiddleware])
  .inputValidator((data: RouteCreateInput) => {
    const name = data.name?.trim()
    const url = data.url?.trim()
    if (!name || !url) {
      throw new Error("name and url are required")
    }
    return { name, url }
  })
  .handler(async ({ data }): Promise<Route> => {
    let id: string
    try {
      id = rwgpsIdFromUrl(data.url)
    } catch {
      throw new Error("url must be a valid RideWithGPS route URL")
    }

    const routes = getRoutes()
    if (routes.some((r) => r.id === id)) {
      throw new Error("Route with this ID already exists")
    }

    const route: Route = { id, name: data.name, url: data.url }
    routes.push(route)
    saveRoutes(routes)
    return route
  })

export interface RouteDeleteInput {
  routeId: string
}

export const routeDelete = createServerFn({ method: "POST" })
  .middleware([adminAuthMiddleware])
  .inputValidator((data: RouteDeleteInput) => {
    const routeId = data.routeId?.trim()
    if (!routeId) throw new Error("routeId is required")
    return { routeId }
  })
  .handler(async ({ data }) => {
    const routes = getRoutes()
    const index = routes.findIndex((r) => r.id === data.routeId)
    if (index === -1) {
      throw new Error("Route not found")
    }

    routes.splice(index, 1)
    saveRoutes(routes)
    return { ok: true as const }
  })
